import {
    SET_GENERAL_TEXT,
    SET_DOWNLOAD_EVERYTHING_TEXT,
    SET_RUN_WITH_LOGS_TEXT,
    SET_RUN_WITH_DX9_TEXT,
    SET_MINIMIZE_TO_TRAY_TEXT,
    SET_LANGUAGE_TEXT,
    SET_RESET_TEXT,
    SET_FORGET_ALL_ACCOUNTS_TEXT,
    SET_FORGET_ALL_ACCOUNTS_TOOLTIP_TEXT,
    SET_SHARED_CACHE_SETTINGS_TEXT,
    // SET_RESET_TO_DEFAULTS_TEXT,
    SET_MANAGE_API_PERMISSIONS_TEXT,
    SET_TEST_SERVERS_TEXT,
    SET_LAUNCH_OPTIONS_TEXT,
    SET_AUTO_LAUNCH_ON_LOGIN_TEXT,
    SET_AUTO_LAUNCH_ON_LOGIN_TOOLTIP_TEXT,
    SET_AUTO_LAUNCH_ON_STARTUP_TEXT,
    SET_AUTO_LAUNCH_ON_STARTUP_TOOLTIP_TEXT,
    SET_LAUNCH_DELAY_TEXT,
    SET_SECONDS_TEXT,
    SET_CONFIRM_FORGET_TEXT,
    SET_SETTING_SAVED_TITLE_TEXT,
    // SET_SETTING_SAVED_MESSAGE_TEXT,
    SET_LAYOUT_TEXT,
    SET_LAYOUT_DEFAULT_TEXT,
    SET_LAYOUT_RIGHT_TEXT,
    SET_LAYOUT_LEFT_TEXT,
    SET_TEXTS,
} from './constants'

export function setGeneralText(text) {
    return {
        type: SET_GENERAL_TEXT,
        payload: text,
    }
}

export function setDownloadEverythingText(text) {
    return {
        type: SET_DOWNLOAD_EVERYTHING_TEXT,
        payload: text,
    }
}

export function setRunWithLogsText(text) {
    return {
        type: SET_RUN_WITH_LOGS_TEXT,
        payload: text,
    }
}

export function setRunWithDx9Text(text) {
    return {
        type: SET_RUN_WITH_DX9_TEXT,
        payload: text,
    }
}

export function setMinimizeToTrayText(text) {
    return {
        type: SET_MINIMIZE_TO_TRAY_TEXT,
        payload: text,
    }
}

export function setLanguageText(text) {
    return {
        type: SET_LANGUAGE_TEXT,
        payload: text,
    }
}

export function setResetText(text) {
    return {
        type: SET_RESET_TEXT,
        payload: text,
    }
}

export function setForgetAllAccountsText(text) {
    return {
        type: SET_FORGET_ALL_ACCOUNTS_TEXT,
        payload: text,
    }
}

export function setForgetAllAccountsTooltipText(text) {
    return {
        type: SET_FORGET_ALL_ACCOUNTS_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setSharedCacheText(text) {
    return {
        type: SET_SHARED_CACHE_SETTINGS_TEXT,
        payload: text,
    }
}

// export function setResetToDefaultsText(text) {
//     return {
//         type: SET_RESET_TO_DEFAULTS_TEXT,
//         payload: text,
//     }
// }

export function setManageApiPermissionsText(text) {
    return {
        type: SET_MANAGE_API_PERMISSIONS_TEXT,
        payload: text,
    }
}

export function setTestServersText(text) {
    return {
        type: SET_TEST_SERVERS_TEXT,
        payload: text,
    }
}

export function setLaunchOptionsText(text) {
    return {
        type: SET_LAUNCH_OPTIONS_TEXT,
        payload: text,
    }
}

export function setAutoLaunchOnLoginText(text) {
    return {
        type: SET_AUTO_LAUNCH_ON_LOGIN_TEXT,
        payload: text,
    }
}

export function setAutoLaunchOnLoginTooltipText(text) {
    return {
        type: SET_AUTO_LAUNCH_ON_LOGIN_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setAutoLaunchOnStartupText(text) {
    return {
        type: SET_AUTO_LAUNCH_ON_STARTUP_TEXT,
        payload: text,
    }
}

export function setAutoLaunchOnStartupTooltipText(text) {
    return {
        type: SET_AUTO_LAUNCH_ON_STARTUP_TOOLTIP_TEXT,
        payload: text,
    }
}

export function setLaunchDelayText(text) {
    return {
        type: SET_LAUNCH_DELAY_TEXT,
        payload: text,
    }
}

export function setSecondsText(text) {
    return {
        type: SET_SECONDS_TEXT,
        payload: text,
    }
}

export function setConfirmForgetText(text) {
    return {
        type: SET_CONFIRM_FORGET_TEXT,
        payload: text,
    }
}

export function setSettingSavedTitleText(text) {
    return {
        type: SET_SETTING_SAVED_TITLE_TEXT,
        payload: text,
    }
}

// export function setSettingSavedMessageText(text) {
//     return {
//         type: SET_SETTING_SAVED_MESSAGE_TEXT,
//         payload: text,
//     }
// }

export function setLayoutText(text) {
    return {
        type: SET_LAYOUT_TEXT,
        payload: text,
    }
}

export function setLayoutDefaultText(text) {
    return {
        type: SET_LAYOUT_DEFAULT_TEXT,
        payload: text,
    }
}

export function setLayoutRightText(text) {
    return {
        type: SET_LAYOUT_RIGHT_TEXT,
        payload: text,
    }
}

export function setLayoutLeftText(text) {
    return {
        type: SET_LAYOUT_LEFT_TEXT,
        payload: text,
    }
}

export function setTexts(texts) {
    return {
        type: SET_TEXTS,
        payload: texts,
    }
}



// WEBPACK FOOTER //
// ./src/features/Settings/data/texts/actions.js